import { render } from "./DataAnalytics.vue?vue&type=template&id=08ff4f1b"
import script from "./DataAnalytics.vue?vue&type=script&lang=js"
export * from "./DataAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\vue-notus-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__